module.exports = __webpack_public_path__ + "static/media/Quote 2 - Mobile.8a385c1b.png";